import React from 'react';
import { VenueCategory } from "../../../../../types/venue";

// @ts-ignore
import Styles from "./SubCategoryBoxView.module.sass"

const SubCategoryBoxView = (props: { category: VenueCategory, onClick: (id: string) => {} }) => {

  const { category, onClick } = props;

  return <div onClick={() => onClick(category.id)}
              className={`${Styles.container} ${category.selected ? Styles.selected : ''}`}>
    <div className={Styles.imageContainer}>
      <div className={Styles.image} style={ {backgroundImage: `url('${category.app_image_url}')`}}/>
    </div>

    <div className={Styles.name}>
      { category.name }
    </div>
  </div>

}

export default SubCategoryBoxView;
